import { BFFAgent } from 'BFFAgent'
import { put, call } from 'redux-saga/effects'
import {
  TAKING_CAR_PURCHACE_SELL_POSSIBLE_ACTIONS_FAILURE,
  TAKING_CAR_PURCHACE_SELL_POSSIBLE_ACTIONS_SUCCESS
} from '../constants'

export function* getSellPossibleActions({ data: { statusId } }) {
  try {
    const possibleActions = yield call(
      BFFAgent.Stock.TakingCarManagement.getStateMachine,
      statusId,
      true
    )

    if (possibleActions) {
      yield put({
        type: TAKING_CAR_PURCHACE_SELL_POSSIBLE_ACTIONS_SUCCESS,
        data: possibleActions.possible_action
      })
    }
  } catch (error) {
    yield put({
      type: TAKING_CAR_PURCHACE_SELL_POSSIBLE_ACTIONS_FAILURE,
      data: { error }
    })
  }
}
